import { Empty } from 'antd';
import { Button } from '@bancobarigui/barihaus';
import { PlusOutlined } from '@ant-design/icons';
import { InspectionItemStatus } from '@/shared/enums/InspectionStatus';

interface EmptyReportStateProps {
  itemStatus: InspectionItemStatus | undefined;
  hasCompletedVideoCall: boolean;
  canCreateLaudo: boolean;
  isInspector: boolean;
  isProvider: boolean;
  isBank: boolean;
  isAutomaticReportFlow: boolean;
  isAwaitingBankFill?: boolean;
  isAwaitingProviderReview: boolean;
  onCreateLaudo: () => void;
}
export function EmptyReportState({
  itemStatus,
  hasCompletedVideoCall,
  canCreateLaudo,
  isInspector,
  isProvider,
  isBank,
  isAutomaticReportFlow,
  isAwaitingBankFill,
  isAwaitingProviderReview,
  onCreateLaudo,
}: EmptyReportStateProps) {
  const getEmptyDescription = () => {
    if (isInspector) {
      if (hasCompletedVideoCall && itemStatus === InspectionItemStatus.TelevistoriaFinalizada) {
        return 'Televistoria finalizada. Preencha o checklist para enviar à Prestadora.';
      }
      if (isAwaitingProviderReview) {
        return 'Aguardando a Prestadora gerar o laudo.';
      }
      return 'Nenhum laudo gerado ainda';
    }

    if (isAwaitingBankFill) {
      return 'Laudo Automático (AVM): Preencha o laudo de avaliação — ao enviar, ele já fica aceito pelo Banco.';
    }

    if (isAutomaticReportFlow) {
      return 'Laudo Automático: Preencha o laudo de avaliação e envie para o Banco.';
    }

    if (canCreateLaudo) {
      return 'Checklist preenchido pelo inspetor. Gere o laudo de avaliação.';
    }

    return 'Nenhum laudo gerado ainda';
  };

  const showInspectorButton = isInspector &&
    hasCompletedVideoCall &&
    itemStatus === InspectionItemStatus.TelevistoriaFinalizada;

  const showProviderBankButton = (isProvider || isBank) && canCreateLaudo;

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={getEmptyDescription()}
    >
      {showInspectorButton && (
        <Button buttonColor="primary" icon={<PlusOutlined />} onClick={onCreateLaudo}>
          Preencher Checklist
        </Button>
      )}
      {showProviderBankButton && (
        <Button buttonColor="primary" icon={<PlusOutlined />} onClick={onCreateLaudo}>
          Gerar Laudo
        </Button>
      )}
    </Empty>
  );
}
